import { SET_DOCUMENT_ACTIVITY_DATA,SET_DOCUMENT_PREVIEW_DATA } from "../config";

const INITIAL_STATE={
  documentActivity:[]
}
export function documentActivityReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case SET_DOCUMENT_ACTIVITY_DATA:
      state = {...state, documentActivity:action.documentActivity};
      return state;
	  case SET_DOCUMENT_PREVIEW_DATA:
      state = {...state, documentPreview:action.documentPreview};
      return state;
    default:
      return state;
  }
}